import { render, staticRenderFns } from "./MyFavorite.vue?vue&type=template&id=3d0b70c8&scoped=true"
import script from "./MyFavorite.vue?vue&type=script&lang=js"
export * from "./MyFavorite.vue?vue&type=script&lang=js"
import style0 from "./MyFavorite.vue?vue&type=style&index=0&id=3d0b70c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0b70c8",
  null
  
)

export default component.exports